import getCombatantNextRoundAction from './getCombatantNextRoundAction'
import getCombatantLastRoundAction from './getCombatantLastRoundAction'
import getCombatantExtraAttackInvalidReason from './getCombatantExtraAttackInvalidReason'
import hasFutureSlots from './hasFutureSlots'
import store from '../store/index'
//-------------------
// get extra attacks
//-------------------
export default async function getExtraAttacks(parm) {
  const this_store = store.state.combat
  const maxCA = this_store.config.max_ca
  const maxCR = this_store.config.max_cr
  const caExtra = maxCA + 1
  const combatants = this_store.arena.arena_combatants
  const activeCombatants = combatants.filter(
    (combatant) =>
      combatant.status == 'Active' &&
      combatant.counters == 0 &&
      (combatant.shield || combatant.second_weapon),
  )
  const extraAttackCombatants = []

  for (const combatant of activeCombatants) {
    const slots = await hasFutureSlots({
      id: combatant.id,
      this_round: parm.round,
      this_number: caExtra,
    })

    if (slots.futureActions) {
      continue
    }

    const lastAction = getCombatantLastRoundAction(combatant, maxCA, parm.round)
    const nextAction = await getCombatantNextRoundAction(combatant, parm.round)
    const invalidReason = getCombatantExtraAttackInvalidReason({
      combatant,
      maxCA,
      maxCR,
      nextAction,
      onCounters: Boolean(slots.futureMarkers),
      currentRound: parm.round,
    })

    if (invalidReason !== '' || !lastAction.action?.eligible_extra_attack_last_action) {
      continue
    }

    extraAttackCombatants.push(combatant)
  }

  console.log('getExtraAttacks: extra_attack_combatants = ', extraAttackCombatants)
  return extraAttackCombatants
}
